import {
  IFillDataWizardSell,
  TKeyOfDataWizardSell,
  TNumberKeysOfIFillDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../..";
import KnowPriceStep_1 from "../knowPrice/step_1";
import KnowPriceStep_10 from "../knowPrice/step_10";
import KnowPriceStep_2 from "../knowPrice/step_2";
import KnowPriceStep_3 from "../knowPrice/step_3";
import KnowPriceStep_4 from "../knowPrice/step_4";
import KnowPriceStep_5 from "../knowPrice/step_5";
import KnowPriceStep_6 from "../knowPrice/step_6";
import KnowPriceStep_7 from "../knowPrice/step_7";
import KnowPriceStep_8 from "../knowPrice/step_8";
import KnowPriceStep_9 from "../knowPrice/step_9";

const getKnowPriceSteps = (
  data: IFillDataWizardSell,
  dataFormEstimate: Partial<IFillDataWizardSell>,
  dataFeatures: Partial<IFillDataWizardSell>,
  onReset: (keys: TKeyOfDataWizardSell[], data?: number[]) => void,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardSell
  ) => void,
  handleChangeDataNumber: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardSell
  ) => void,
  handleChangeDataObject: (data: Partial<IFillDataWizardSell>) => void,
  disabledAndPrev: {
    isNextStep_estimate: boolean;
    isNextStep_dataFeatures: boolean;
    isNextStep_offersForClient: boolean;
    isNextStep_communicationType: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
    isFourStepPrev: boolean
  }
) => {
  const {
    isNextStep_estimate,
    isNextStep_dataFeatures,
    isNextStep_offersForClient,
    isNextStep_communicationType,
    isNextStep_viewRealtorParticipation,
    isNextStep_timeIntervalTypeCommunication,
    isFourStepPrev,
  } = disabledAndPrev;

  return [
    <KnowPriceStep_1 />,
    <KnowPriceStep_2
      onChange={handleChangeDataString}
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onReset={onReset}
    />,
    <KnowPriceStep_3
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onChange={handleChangeDataString}
      onReset={onReset}
    />,
    <KnowPriceStep_4
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onChange={handleChangeDataString}
      onReset={onReset}
    />,
    <KnowPriceStep_5
      data={data.offersForClient}
      isNextStepDisabled={isNextStep_offersForClient}
      onChange={handleChangeDataString}
      onReset={onReset}
    />,
    <KnowPriceStep_6 />,
    <KnowPriceStep_7
      dataFormEstimate={dataFormEstimate}
      isNextStepDisabled={isNextStep_estimate}
      onChangePrice={handleChangeDataNumber}
      onChange={handleChangeDataObject}
      onReset={onReset}
    />,
    <KnowPriceStep_8
      data={data.wishPriceSell}
      onChange={handleChangeDataNumber}
      onReset={onReset}
    />,
    <KnowPriceStep_9
      data={dataFeatures}
      isNextStepDisabled={isNextStep_dataFeatures}
      onChange={handleChangeDataObject}
      onReset={onReset}
    />,
    <KnowPriceStep_10 data={data} isFourStepPrev={isFourStepPrev}/>,
  ];
};

export default getKnowPriceSteps;
